import React, { useEffect, useState, useReducer } from "react";
import { Form, Toast, ToastContainer, Button } from "react-bootstrap";
import { axiosOpen } from "../../api/axios";
import { getUserID } from "../../service";


const ApiKey = () => {

  const userID = getUserID();
  const [apiKey, setApiKey] = useState('');
  const [keyRecord, setKeyRecord] = useState('');
  const [loader, setLoader] = useState(true);

  const fetchApiKey = async () => {
    const response = await axiosOpen.get(`/api/customer/getgptkey/${userID}`);
    setApiKey(response?.data?.keyRecord?.chatgptapikey);
    setLoader(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const response = await axiosOpen.post(`/api/customer/registerkey/${userID}`, {"chatgptapikey": keyRecord});
    if(response){
      setApiKey(keyRecord);
    }
  };

  const updateHandleSubmit = async (e) => {
    e.preventDefault();
    const response = await axiosOpen.post(`/api/customer/updategptkey/${userID}`, {"chatgptapikey": apiKey});
    console.log(response);
  };

  useEffect(() => {
    fetchApiKey();
  }, []);

  return (
    <>
    {!loader && apiKey &&
      <div className="Api-main-body container">
      <h2 className="py-3">ApiKey</h2>
      <Form  className="add-api-key">
        <Form.Group className="mb-3" controlId="formBasicApiKey">
          <Form.Label>Your API Key</Form.Label>
          <Form.Control
            value={apiKey}
            onChange={(e) => {
              setApiKey(e.target.value);
            }}
            type="text"
          />
        </Form.Group>
        <Button variant="primary" type="submit" onClick={updateHandleSubmit}>
          Update
        </Button>
      </Form>
    </div>
    }
    {!loader && !apiKey && 
      <div className="Api-main-body container">
        <h2 className="py-3">Open AI Api Key</h2>
        <Form  className="add-api-key">
          <Form.Group className="mb-3" controlId="formBasicApiKey">
            <Form.Control
              value = {keyRecord}
              onChange={(e) => {
                setKeyRecord(e.target.value);
              }}
            />
          </Form.Group>
          <Button variant="primary" type="submit" onClick={handleSubmit}>
            Submit
          </Button>
        </Form>
      </div>}
    </>
  );
};

export default ApiKey;